import React, { Component } from 'react';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withPreference from '../../common/withPreference';
import Bugsnag from '../../helpers/bugsnag';

class CopyPreferenceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: ''
    };
    this.copyPreferenceModal = null;
  }

  componentDidMount() {
    try {
      this.copyPreferenceModal = new window.bootstrap.Modal(window.$('#copyPreferenceModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = () => {
    const {
      notify, onSavePreference
    } = this.props;
    const { name } = this.state;

    if (name && !/^[ _]*[A-Z0-9][A-Z0-9 _]*$/i.test(name)) {
      notify({
        type: 'warning',
        message: 'You can only use letters, numbers, spaces, and underscores in the preference name.'
      });
      return;
    }
    if (name !== '') {
      this.copyPreferenceModal.hide();
      onSavePreference(name);
      this.setState({ name: '' });
    } else {
      notify({ type: 'warning', message: 'Please enter preference name' });
    }
  }

  _onChangeName = (e) => {
    this.setState({ name: e.target.value });
  }

  _onGoBack = () => {
    this.setState({ name: '' });
  }

  render() {
    const { name } = this.state;
    return (
      <div
        className="modal fade theme-modal qty-modal" id="copyPreferenceModal"
        tabIndex="-1"
        aria-labelledby="copyPreferenceModalLabel" aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="copyPreferenceModalLabel">Copy Preference</h5>
              <p>Give the copy a unique name:</p>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control text-uppercase"
                  placeholder="Name"
                  value={name}
                  id="copyPrefName"
                  onChange={this._onChangeName}
                />
              </div>
            </div>
            <div className="modal-footer">
              <div className="row gx-2 button-wrap">
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link btn-left w-100"
                    data-bs-dismiss="modal"
                    onClick={this._onGoBack}
                  >Back
                  </button>
                </div>
                <div className="col-6">
                  <button
                    type="button" className="btn btn-link w-100"
                    onClick={this._onSubmit}
                  >Copy & Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withPreference(withGoBack(withNotify(withLoader(CopyPreferenceModal))));
